// The built-int serviceWorker.ready is not sufficient. Use this as an improved version.
// Background: https://github.com/mafintosh/browser-server/issues/6
// > "It seems that there is a small wait between when the .ready method is called and the serviceworker actually claims the client."
export default function ready() {
  return new Promise((resolve) => {

    // There is no service worker in development
    if (import.meta.env.DEV) {
      resolve()
      return
    }

    // Service worker is ready
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.getRegistration().then(resolve)
      return
    }

    // Wait for service worker to become ready
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      navigator.serviceWorker.getRegistration().then(resolve)
    }, { once: true });
  })
}